<section>
  <div class="header astral-page-header">
    <h1>{{ 'DASHBOARD.MENU.REPORT_MEMBERSHIP_LIST' | translate }}</h1>
    <div class="astral-page-header__actions">
      <astral-button variant="primary" size="small" type="button" icon="print" labelKey="PRINT_BTN" (click)="onPrintPages()"></astral-button>
      <astral-button
        variant="primary"
        size="small"
        type="button"
        icon="excel"
        labelKey="COMMON.EXCEL"
        [disabled]="isExportDisabled"
        (click)="exportExcel()"
      ></astral-button>
    </div>
  </div>

  <div class="filter astral-section-surface astral-form-stack astral-form-stack--relaxed report-filter-surface">
    <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
      <app-autocomplete-remote
        [control]="form.controls['companyId']"
        [service]="companyService"
        [defaultSearch]="'*'"
      ></app-autocomplete-remote>
      <astral-date-picker [control]="form.controls['reportDate']"></astral-date-picker>
    </astral-layout-group>
  </div>

  @if (dataContext) {
    <app-list-view
      [columnDefinition]="columnDefinitions"
      [itemsSource]="dataContext"
      [preferencesKey]="'report.membership-list'"
    ></app-list-view>
  }
</section>
